import React, { Component } from 'react'
import PropTypes from 'prop-types'
import WidgetContainer from '../../containers/WidgetContainer'
import utmLinkGenerator from '../../utils/UTMLinkGenerator'
import BoxWrapper from './StyledBoxWrapper'
import FutroBox from './FutroBox'
import { GA_ENHANCED_ECOMMERCE } from '../../../constants'

class Futro extends Component {
  componentDidMount () {
    this.props.googleAnalytics.event(GA_ENHANCED_ECOMMERCE.IMPRESSION_PAYLOAD)
  }

  render () {
    const {
      widget,
      widget: {
        boxes
      },
      googleAnalytics
    } = this.props

    if (!boxes || !boxes.length) {
      return null
    }

    return (
      <WidgetContainer googleAnalytics={googleAnalytics} widget={widget} showBottomLine={false}>
        <BoxWrapper>
          {
            boxes.map((box, index) => {
              const {
                widget: {
                  imageSize,
                  utmMedium
                }
              } = this.props

              const {
                guid,
                images,
                link,
                source
              } = box

              const utmParams = {
                utmCampaign: source,
                utmMedium
              }

              const image = images[imageSize]
              const utmLink = utmLinkGenerator.createLinkWithOriginalQuery(link, utmParams)

              const boxWithImageAndUtm = Object.assign({}, box, {
                image,
                link: utmLink
              })

              return <FutroBox box={boxWithImageAndUtm} key={guid} googleAnalytics={googleAnalytics} position={index}/>
            })
          }
        </BoxWrapper>
      </WidgetContainer>
    )
  }
}

Futro.propTypes = {
  widget: PropTypes.object.isRequired,
  googleAnalytics: PropTypes.object
}

export default Futro
